import './style.css';

class AnimatedPng {
    constructor(el, options) {
        let default_options = {
            src: '',
            width: 370,
            height: 300,
            frames: 20,
            duration: '1.75s'
        }

        options = Object.assign(default_options, options);

        this.el = el;        
        this.el.classList.add('animated-png');
        this.el.style.setProperty('--width', options.width + 'px');
        this.el.style.setProperty('--height', options.height + 'px');
        this.el.style.setProperty('--aspect-ratio', options.width + ' / ' + options.height);
        this.el.style.setProperty('--frames', options.frames);
        this.el.style.setProperty('--duration', '1.75s');
 
        let img = document.createElement('IMG');

        img.addEventListener('load', () => {
            this.el.classList.add('ready');
            this.el.classList.add('animated');
        })
        
        img.setAttribute('src', options.src);
        this.el.append(img);
    }
}

export function animated_png(el, options) {
    new AnimatedPng(el, options);
}